import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { UnsafeRepricingConfirmModalService } from '../../services/unsafe-repricing-confirm-modal.service';

@Component({
  selector: 'app-unsafe-repricing-confirm-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, TranslateModule],
  templateUrl: './unsafe-repricing-confirm-modal.component.html',
  styleUrls: ['./unsafe-repricing-confirm-modal.component.scss'],
})
export class UnsafeRepricingConfirmModalComponent {
  private readonly modal = inject(UnsafeRepricingConfirmModalService);

  readonly state = this.modal.state;
  readonly isList = computed(() => this.state().detailsList.length > 1);
  readonly priceText = computed(() => {
    const details = this.state().details;
    return {
      currentPrice: this.formatPrice(details?.current_price),
      proposedPrice: this.formatPrice(details?.proposed_price),
    };
  });
  readonly priceRows = computed(() =>
    this.state().detailsList.map((details) => ({
      details,
      currentPrice: this.formatPrice(details.current_price),
      proposedPrice: this.formatPrice(details.proposed_price),
    }))
  );
  readonly selectedCount = computed(() => this.state().selectedProductIds.length);

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.modal.cancel();
    }
  }

  confirm(): void {
    this.modal.confirm();
  }

  cancel(): void {
    this.modal.cancel();
  }

  isSelected(productId: string): boolean {
    return this.state().selectedProductIds.includes(productId);
  }

  toggleSelection(productId: string, event: Event): void {
    const selected = (event.target as HTMLInputElement).checked;
    this.modal.setSelection(productId, selected);
  }

  private formatPrice(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return '-';
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return String(value);
    }

    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(numericValue);
  }
}
